import Restraint from "./Restraint.js";
import Connector from "../connectors/Connector";

/** */
export default class ConnectorRestraint extends Restraint {

    /** @type {Connector} */
    sceneConnector;
    /** @type {Connector} */
    handleConnector;

    constructor(options) {
        super(options);
        this.sceneConnector = options.sceneConnector;
        this.handleConnector = options.handleConnector;
    }

    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        return ray.intersectBox( this.dragObject3dBoundingBoxLocal);
    }

    perform(raycaster, point, dropped) {
        this.dragObject3d.copyMatrix(this.matrixWorld);
    }

    createVisualization(restraintHandler) {
        const size = this.dragObject3dBoundingBoxLocal.getSize();
        const geometry = restraintHandler.boxPreviewGeometryCache(size.x,size.y,size.z);
        const group = new THREE.Group();
        restraintHandler.boxPreviewMaterials.forEach((material,index)=>{
            const mesh = new THREE.Mesh(geometry, material);
            mesh.renderOrder = index+1;
            mesh.position.copy(this.dragObject3dBoundingBoxLocal.getCenter());
            group.add(mesh);
        });
        return group;
    }

}

